import { FileUploader } from '@cartwhl/ui/feature/FileUploader';
import Button from '@cartwhl/ui/input/Button';

import { navigationStore } from 'stores';

import { IMAGE_EXTENSIONS, MAX_FILE_SIZE } from '../constants';

export default function ImageUploadModal({ close }: { close: () => void }) {
  // Note: imageUpload will be added to animationGenerationStore.state later
  // const { imageUpload } = useSnapshot(animationGenerationStore.state);

  return (
    <div className="h-1/2">
      <FileUploader
        fileContent="Image"
        accept={{ 'image/*': IMAGE_EXTENSIONS }}
        cancelable={false}
        maxFileSize={MAX_FILE_SIZE}
        // upload={imageUpload}
        onDrop={(file) => {
          // Placeholder for image upload - will be implemented later
          console.log('Image upload placeholder:', file);
        }}
        onRemove={() => {
          navigationStore.setModal('');
        }}
      />

      <div className="mt-6">
        <Button onClick={close}>Cancel</Button>
      </div>
    </div>
  );
}
